import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import OvAccountsCostChart from "./OvAccountsCostChart";
import OvAccountsCoresChart from "./OvAccountsCoresChart";
import OvAccountsMinutesChart from "./OvAccountsMinutesChart";
import OvAccountsStorageChart from "./OvAccountsStorageChart";
import UIFocusSwitchContainer from "./UIFocusSwitchContainer";

import OvAccountsInfoCard from "./OvAccountsInfoCard";

const styles = theme => ({
  root: {
    padding: 20
  }
});

const OvAccountsView = props => {
  const { classes } = props;
  return (
    <div className={classes.root}>
      <OvAccountsInfoCard {...props} />
      <OvAccountsCostChart {...props} />
      <OvAccountsCoresChart {...props} />
      <OvAccountsMinutesChart {...props} />
      <OvAccountsStorageChart {...props} />
      <UIFocusSwitchContainer />
    </div>
  );
};

OvAccountsView.propTypes = {
  data: PropTypes.array.isRequired,
  filterState: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired
};

export { OvAccountsView };

export default withStyles(styles, { name: "OvAccountsView" })(OvAccountsView);



// WEBPACK FOOTER //
// ./src/OvAccountsView.js